export default __webpack_public_path__ + "static/profile-img01-4ff1ba8315d6daa43ab5014158f0bb20.png";